import { NoData } from "@";
import PaginationComponent from "@/shared/components/dataTable/Pagination";
import type { FC } from "react";
import {
  cardEmptySurface,
  cardFooterBar,
  cardGridGap,
  cardGridStack,
} from "../../shared/cards";
import type { LandingPage } from "../types";
import { LandingPageCard, LandingPageCardSkeleton } from "./LandingPageCard";

const Pagination = PaginationComponent as unknown as FC<{
  localPg?: boolean;
  totalRows: number;
  currentPage: number;
  totalPages: number;
  rowsPerPage: number;
  rowsPerPageOptions?: (number | "all")[];
  onPageChange: (page: number) => void;
  onRowsPerPageChange?: (size: number) => void;
}>;

interface Props {
  data: LandingPage[];
  isLoading: boolean;
  totalItems: number;
  pg: { page: number; size: number };
  updatePg: (p: { page?: number; size?: number }) => void;
  deleteHandler: (id: number) => Promise<void>;
  togglePublish: (id: number, value: boolean) => Promise<void>;
}

const GRID_CLASS = `grid grid-cols-1 ${cardGridGap} md:grid-cols-2 2xl:grid-cols-3`;

export const LandingPagesGrid = ({
  data,
  isLoading,
  totalItems,
  pg,
  updatePg,
  deleteHandler,
  togglePublish,
}: Props) => {
  if (isLoading) {
    return (
      <div className={GRID_CLASS}>
        {Array.from({ length: 3 }).map((_, i) => (
          <LandingPageCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className={cardEmptySurface}>
        <NoData />
      </div>
    );
  }

  const totalPages = Math.max(1, Math.ceil(totalItems / pg.size));

  return (
    <div className={cardGridStack}>
      <div className={GRID_CLASS}>
        {data.map((page) => (
          <LandingPageCard
            key={page.id}
            page={page}
            deleteHandler={deleteHandler}
            togglePublish={togglePublish}
          />
        ))}
      </div>

      {totalItems > 1 && (
        <div className={cardFooterBar}>
          <Pagination
            localPg={false}
            totalRows={totalItems}
            currentPage={pg.page}
            totalPages={totalPages}
            rowsPerPage={pg.size}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onPageChange={(page: number) => updatePg({ page })}
            onRowsPerPageChange={(size: number) => updatePg({ size, page: 1 })}
          />
        </div>
      )}
    </div>
  );
};
